import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import AdminHeader from '../Header/AdminHeader';
import AdminFooter from '../siteadmin/AdminFooter';
import SideBar from '../siteadmin/SideBar';
import history from '../../core/history';
import OffcanvasMenu from '../siteadmin/SideBar/MobileSideBar/OffcanvasMenu';
import s from './AdminLayout.css';

class AdminLayout extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  };

  render() {
    let location;
    if (history.location) {
      location = history.location.pathname
    }
    return (
      <div>
        <AdminHeader />
        <aside className={cx(s.sideMenuContainer, "hidden-print")}>
          <div className={cx(s.sideMenuWrapper, 'sideMenuWrapperRtl')}>
            <SideBar location={location} />
          </div>
        </aside>
        <OffcanvasMenu location={location} />
        <main className={cx(s.adminMainContentWrapper, 'adminMainContentWrapperRTL')}>
          {this.props.children}
        </main>
        <AdminFooter />
      </div>
    );
  }
}

export default withStyles(s)(AdminLayout);